import { gql } from '@apollo/client';

export const GET_STATION_LIST_BY_BUSINESS_TYPE = gql`
    query GetStationListByBusinessType($businessType: Int!) {
        getStationListByBusinessType(businessType: $businessType) {
            id
            name
            sortingCode
            addressLine1
            addressLine2
            country
            state
            city
            zipcode
            contactName
            phoneNumber
            timezoneLocation
            siteType
            parentSiteId
        }
    }
`;

export interface TmsStation {
    id: number | null;
    name: string | null;
    sortingCode: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    country: string | null;
    state: string | null;
    city: string | null;
    zipcode: string | null;
    contactName: string | null;
    phoneNumber: string | null;
    timezoneLocation: string | null;
    siteType: number | null;
    parentSiteId: number | null;
    stationSource: string | null;
    stationType: number | null;
    // 是否测试站点：内部站点取 warehouse.is_test_warehouse，外部站点取 external_station.is_test
    isTest: boolean;
}

export interface GetStationListByBusinessTypeResponse {
    getStationListByBusinessType: TmsStation[];
}

export const GET_ALL_STATIONS = gql`
    query GetAllStations {
        getAllStations {
            id
            name
            sortingCode
            addressLine1
            addressLine2
            country
            state
            city
            zipcode
            contactName
            phoneNumber
            timezoneLocation
            siteType
            parentSiteId
            stationSource
            stationType
            isTest
        }
    }
`;

export interface GetAllStationsResponse {
    getAllStations: TmsStation[];
}
